import { render, staticRenderFns } from "./official_list.vue?vue&type=template&id=58e0bbce"
import script from "./official_list.vue?vue&type=script&lang=js"
export * from "./official_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports